@if (!loading) {
  <router-outlet></router-outlet>
} @else {
  <div class="d-flex h-100">
    <ng-lottie class="d-flex align-self-center m-auto" [options]="options"></ng-lottie>
  </div>
}

